const SwitchModule = {
  namespaced: true,
  state: {
    contraception1: [
      "Anneau vaginal",
      "DIU au cuivre",
      "Implant",
      "Patch",
      "Pilule OP",
      "DIU à la progestérone",
      "Pilule microprogestative",
    ],
    contraceptionFuture: [
      "Anneau vaginal",
      "DIU au cuivre",
      "Implant",
      "Patch",
      "Pilule OP",
      "DIU à la progestérone",
      "Pilule microprogestative",
      "Depo-provera",
    ],
    selectedContraception1: "",
    selectedContraception2: "",
    result: "",
  },
  getters: {
    getContraception1(state) {
      return state.contraception1;
    },
    getFuturContraception(state) {
      return state.contraceptionFuture;
    },
    getResult(state) {
      return state.result;
    },
  },
  actions: {
    sendSelectedContra1({ commit }, value) {
      commit("SEND_SELECTED_CONTRA1", value);
    },
    sendSelectedContra2({ commit }, value) {
      commit("SEND_SELECTED_CONTRA2", value);
    },
    analyzeQuestion({ commit }) {
      commit("ANALYZE_QUESTIONS");
    },
    resetResult({ commit }) {
      commit("RESET_RESULT");
    },
  },
  mutations: {
    SEND_SELECTED_CONTRA1(state, data) {
      state.selectedContraception1 = data;
    },
    SEND_SELECTED_CONTRA2(state, data) {
      state.selectedContraception2 = data;
    },
    RESET_RESULT(state) {
      state.result = "";
    },
    ANALYZE_QUESTIONS(state) {
      //Pilule
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Enchaîner au jour suivant ou commencer n'importe lequel des jours d'arrêt, si plus de 7 jours préservatif pendant 7 jours avant pilule seule";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "Patch"
      ) {
        state.result =
          "Pose de patch  le lendemain du dernier comprimé de pilule Si démarrage au delà des 7 jours de période d'arrêt, préservatif les 7 premiers jours";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "Anneau vaginal"
      ) {
        state.result =
          "Pose de l'anneau le lendemain du dernier comprimé de pilule. Si démarrage au-delà des 7jours de periode d'arrêt, préservatif les 7 premiers jours.";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "Implant"
      ) {
        state.result = "Relais immédiat après le dernier comprimé actif";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "DIU à la progestérone"
      ) {
        state.result = "Relais immédiat après le dernier comprimé actif";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "Pilule microprogestative"
      ) {
        state.result =
          "Enchaîner la pilule microprogestative après le dernier comprimé actif de la pilule oestroprogestative";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "DIU au cuivre"
      ) {
        state.result =
          "Pose du SIU possible jusqu'à 5 jours après le dernier comprimé actif";
      }
      if (
        state.selectedContraception1 === "Pilule OP" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Relais immédiat : Injection le lendemain du dernier comprimé actif";
      }
      // Anneau
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Commencer pilule le lendemain du jour où on enlève l'anneau. Si démarrage au delà des 7 jours d'arrêt, préservatif les 7 premiers jours";
      }
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "Patch"
      ) {
        state.result =
          "Pose du patch à la suite du retrait de l'anneau sans pause ";
      }
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "Implant"
      ) {
        state.result = "Relais immédiat après retrait de l'anneau";
      }
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "DIU à la progestérone"
      ) {
        state.result = "Relais immédiat après retrait de l'anneau";
      }
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "DIU au cuivre"
      ) {
        state.result =
          "Pose du SIU possible jusqu'à 5 jours après retrait de l'anneau";
      }
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "Pilule microprogestative"
      ) {
        state.result = "Relais immédiat après retrait de l'anneau";
      }
      if (
        state.selectedContraception1 === "Anneau vaginal" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Relais immédiat : Injection le lendemain du retrait de l'anneau";
      }
      // DIU Cuivre && Implant
      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "Implant"
      ) {
        state.result = "Retrait du SIU 7 jours après la pose de l'implant";
      }

      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "DIU à la progestérone"
      ) {
        state.result =
          "Contraception mécanique 7 jours après le changement de SIU";
      }

      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "Anneau vaginal"
      ) {
        state.result =
          "Chevauchement 7 jours : mettre le premier anneau 7 jours avant le retrait du SIU";
      }

      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Chevauchement 7 jours : commencer la pilule oestroprogestative 7 jours avant le retrait du SIU";
      }

      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "Patch"
      ) {
        state.result =
          "Chevauchement 7 jours : mettre le premier patch 7 jours avant le retrait du SIU";
      }

      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "Pilule microprogestative"
      ) {
        state.result =
          "Chevauchement 7 jours : retrait du SIU 7 jours après le début de la pilule microprogestative";
      }

      if (
        state.selectedContraception1 === "DIU au cuivre" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Chevauchement 7 jours : retrait du SIU 7 jours après l'injection";
      }

      // Implant

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Chevauchement 7 jours : commencer la pilule oestroprogestative 7 jours avant le retrait de l'implant";
      }

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Chevauchement 7 jours : retrait de l'implant 7 jours après l'injection";
      }

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "Patch"
      ) {
        state.result =
          "Chevauchement 7 jours : mettre le premier patch 7 jours avant le retrait de l'implant";
      }

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "DIU au cuivre"
      ) {
        state.result = "Retirer l'implant le jour de la pose du SIU";
      }

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "DIU à la progestérone"
      ) {
        state.result = "Retirer l'implant 7 jours après la pose du SIU";
      }

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "Anneau vaginal"
      ) {
        state.result =
          "Chevauchement 7 jours : mettre le premier anneau 7 jours avant le retrait de l'implant";
      }

      if (
        state.selectedContraception1 === "Implant" &&
        state.selectedContraception2 === "Pilule microprogestative"
      ) {
        state.result =
          "Chevauchement 7 jours : retrait de l'implant 7 jours après le début de la pilule microprogestative";
      }
      // if (
      //   state.selectedContraception1 === "Implant" ||
      //   (state.selectedContraception1 === "DIU au cuivre" &&
      //     state.selectedContraception2 === "Pilule microprogestative")
      // ) {
      //   state.result =
      //     "Chevauchement 7 jours : retrait de l'implant 7 jours après le début de la pilule microprogestative";
      // }
      // if (
      //   state.selectedContraception1 === "Implant" ||
      //   (state.selectedContraception1 === "DIU au cuivre" &&
      //     state.selectedContraception2 === "Depo-provera")
      // ) {
      //   state.result =
      //     "Chevauchement 7 jours : retrait de l'implant 7 jours après l'injection";
      // }

      // Patch
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Commencer pilule le lendemain du jour où on enlève le patch. Si démarrage au delà des 7 jours d'arrêt, préservatif les 7 premiers jours";
      }
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "Anneau vaginal"
      ) {
        state.result =
          "Pose du patch à la suite du retrait de l'anneau sans pause";
      }
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "Implant"
      ) {
        state.result = "Relais immédiat après retrait du patch";
      }
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "DIU à la progestérone"
      ) {
        state.result = "Relais immédiat après retrait du patch";
      }
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "Pilule microprogestative"
      ) {
        state.result = "Relais immédiat après retrait du patch";
      }
      // if (
      //   (state.selectedContraception1 === "Patch" &&
      //     state.selectedContraception2 === "Implant") ||
      //   state.selectedContraception2 === "DIU à la progestérone (Mirena)" ||
      //   state.selectedContraception2 === "Pilule microprogestative"
      // ) {
      //   state.result = "Relais immédiat après retrait du patch";
      // }
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "DIU au cuivre"
      ) {
        state.result =
          "Pose du SIU possible jusqu'à 5 jours après  retrait du patch";
      }
      if (
        state.selectedContraception1 === "Patch" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Relais immédiat : Injection le lendemain du retrait du patch";
      }

      // Pilule microprogestative
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Chevauchement 7 jours : commencer la pilule oestroprogestative avant d'arrêter la pilule microprogestative et prendre les deux comprimés pendant 7 jours";
      }
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "Patch"
      ) {
        state.result =
          "Chevauchement 7 jours : poursuivre la pilule 7 jours après la mise en place du premier patch";
      }
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "Anneau vaginal"
      ) {
        state.result =
          "Chevauchement 7 jours : poursuivre la pilule 7 jours après la mise en place du premier anneau";
      }
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "Implant"
      ) {
        state.result =
          "Chevauchement 7 jours : poursuivre la pilule 7 jours après la mise en place de l'implant";
      }
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "DIU à la progestérone"
      ) {
        state.result =
          "Chevauchement 7 jours : poursuivre la pilule 7 jours après la mise en place du SIU";
      }
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "DIU au cuivre"
      ) {
        state.result =
          "Pose du SIU possible jusqu'à 5 jours après le dernier comprimé";
      }
      if (
        state.selectedContraception1 === "Pilule microprogestative" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Chevauchement 7 jours : poursuivre la pilule 7 jours après l'injection";
      }

      // SIU à la progestérone (Mirena)
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "Pilule OP"
      ) {
        state.result =
          "Chevauchement 7 jours : commencer la pilule oestroprogestative 7 jours avant le retrait du SIU";
      }
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "Patch"
      ) {
        state.result =
          "Chevauchement 7 jours : mettre le premier patch 7 jours avant le retrait du SIU";
      }
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "Anneau vaginal"
      ) {
        state.result =
          "Chevauchement 7 jours : mettre le premier anneau 7 jours avant le retrait du SIU";
      }
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "Pilule microprogestative"
      ) {
        state.result =
          "Chevauchement 7 jours : retrait du SIU 7 jours après le début de la pilule microprogestative";
      }
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "Depo-provera"
      ) {
        state.result =
          "Chevauchement 7 jours : retrait du SIU 7 jours après l'injection";
      }
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "Implant"
      ) {
        state.result = "Retirer le SIU 7 jours après la pose de l'implant";
      }
      if (
        state.selectedContraception1 === "DIU à la progestérone" &&
        state.selectedContraception2 === "DIU au cuivre"
      ) {
        state.result =
          "Retrait du DIU à la progestérone le jour de la pose du SIU au cuivre";
      }
    },
  },
};

export default SwitchModule; // export the module
